import React from "react";
import styled from "styled-components";

import { Flex, H4 } from "@appcues/component-library";

import {
  modalPreviewContent,
  tooltipPreviewContent,
  slideoutPreviewContent
} from "constants/account/themes";

import PreviewContainer from "components/Common/PreviewContainer";

const PreviewPanel = ({ theme }) => {
  return (
    <PreviewWrapper>
      <Flex
        backgroundColor="#242A35"
        height="64px"
        alignItems="center"
        paddingLeft="24px"
      >
        <H4 type="secondary" light>
          Preview
        </H4>
      </Flex>
      <PreviewContainer
        theme={theme}
        content={modalPreviewContent}
        height="480px"
      />
      <PreviewContainer
        theme={theme}
        content={tooltipPreviewContent}
        height="256px"
      />
      <PreviewContainer
        theme={theme}
        content={slideoutPreviewContent}
        height="360px"
      />
    </PreviewWrapper>
  );
};

const PreviewWrapper = styled.div`
  height: 100%;
  background-color: ${props => props.theme["$gray-50"]};
  border-left: 1px solid ${props => props.theme["$gray-50"]};
  border-radius: 6px;
  position: relative;
  z-index: 2;
  overflow: hidden;
`;

export default PreviewPanel;
